<template>
  <ul class="accordion">
    <slot></slot>
  </ul>
</template>

<script>
export default {
  props: {
    active: {
      default: 0
    },
    onChange : {
      type: Function,
      default: () => {}
    }
  },
  data() {
    return {
      Accordion: {
        count: 0,
        active: this.active == "null" ? null : parseInt(this.active),
        onChange: this.onChange
      }
    };
  },
  methods: {
    reset() {
      this.Accordion.active = null;
      this.Accordion.count = 0;

      this.onChange(null);
    },
    open(index) {

      this.Accordion.active = index;

      this.onChange(index);
    }
  },
  provide() {
    return { Accordion: this.Accordion };
  }
};
</script>

<style scoped>
.accordion {
  list-style: none;
  margin: 0;
  padding: 0;

}
</style>
